import { Component, Input, Injector, inject } from '@angular/core';
import { Client } from 'app/core/models/client.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageViewModalComponent, ImageViewModalOptions } from 'app/shared/components/image-view-modal/image-view-modal.component';

@Component({
  selector: 'app-client-info-card',
  templateUrl: './client-info-card.component.html',
})
export class ClientInfoCardComponent {
  @Input() client: Client;

  private injector = inject(Injector);
  private modalService = inject(NgbModal);

  get liveTpas(): string[] {
    return this.client.liveThirdPartyAdministers.map((tpa) => tpa.name);
  }

  onLogoClick($event: MouseEvent) {
    $event.preventDefault();
    const modalOptions = new ImageViewModalOptions();
    modalOptions.imageUrl = this.client.logoUrl;
    modalOptions.altText = 'client logo';

    this.modalService.open(ImageViewModalComponent, {
      windowClass: 'image-view-modal',
      injector: Injector.create({
        providers: [{ provide: ImageViewModalOptions, useValue: modalOptions }],
        parent: this.injector
      })
    });
  }
}
